import { render, staticRenderFns } from "./WebsiteCloudflareForm.vue?vue&type=template&id=61fa4567&scoped=true&"
import script from "./WebsiteCloudflareForm.vue?vue&type=script&lang=js&"
export * from "./WebsiteCloudflareForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa4567",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VExpandTransition,VForm,VRow,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61fa4567')) {
      api.createRecord('61fa4567', component.options)
    } else {
      api.reload('61fa4567', component.options)
    }
    module.hot.accept("./WebsiteCloudflareForm.vue?vue&type=template&id=61fa4567&scoped=true&", function () {
      api.rerender('61fa4567', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Connector/components/Website/WebsiteCloudflareForm.vue"
export default component.exports